import { render, staticRenderFns } from "./SummaryTab.vue?vue&type=template&id=774cd018"
import script from "./SummaryTab.vue?vue&type=script&lang=js"
export * from "./SummaryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports